/**
 * iOS Detection Utility
 * Detects iPhone, iPad, and iPod devices including iPadOS 13+
 */

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  
  const ua = navigator.userAgent || '';
  
  // Traditional iOS detection (iPhone, iPod, iPad with older Safari)
  const iOS = /iP(hone|od|ad)/.test(ua);
  
  // iPadOS 13+ detection (reports as MacIntel but has touch support)
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  
  return iOS || iPadOS;
}

export default isIOS;
